import React, { type SVGProps } from "react";

export function SupPoolLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
      <g filter="url(#filter0_i_2113_4469)">
        <rect x="0.666016" y="0.5" width="16.0013" height="16" rx="8" fill="#F5F4FB" />
        <rect x="0.832696" y="0.666681" width="15.668" height="15.6666" rx="7.83332" stroke="#8979D9" strokeWidth="0.333361" />
        <path
          d="M4.63255 7.18163C4.29833 7.53568 4.11184 8.01357 4.11027 8.49919C4.10729 9.42392 4.80535 10.2573 5.72114 10.4123C6.21671 10.4955 6.73728 10.3812 7.14976 10.0928C7.67924 9.7229 8.07449 9.30745 8.78126 9.30712C9.45852 9.30741 9.8487 9.66665 10.3439 10.0428C10.7413 10.3458 11.2503 10.485 11.7463 10.4262C12.0601 10.3889 12.3605 10.2754 12.6184 10.0961C12.7806 9.98368 12.9298 9.84191 13.05 9.68629C13.3116 9.34727 13.4522 8.92667 13.4516 8.49919C13.4512 8.23554 13.3969 7.9732 13.2914 7.73137C13.1763 7.46816 13.0008 7.22694 12.7819 7.03986C12.4587 6.76388 12.0751 6.60586 11.652 6.57485C11.1837 6.54111 10.7093 6.68589 10.3374 6.97193C9.85217 7.34727 9.44111 7.70258 8.78126 7.70257C8.0589 7.70287 7.68208 7.28644 7.14496 6.91359C6.85957 6.7157 6.53246 6.60088 6.18042 6.57485C6.11655 6.57005 5.97072 6.57005 5.90685 6.57485C5.48282 6.60642 5.09553 6.76665 4.77654 7.04318C4.72448 7.08822 4.68645 7.12478 4.63255 7.18163Z"
          fill="#3F3280"
        />
        <circle cx="8.66587" cy="5.29966" r="1.59946" fill="#3F3280" />
        <ellipse cx="8.66587" cy="11.7002" rx="1.59946" ry="1.59946" fill="#3F3280" />
      </g>
      <defs>
        <filter id="filter0_i_2113_4469" x="0.666016" y="0.5" width="16.002" height="16" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="3.20027" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.286275 0 0 0 0 0.721569 0 0 0 0.22 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2113_4469" />
        </filter>
      </defs>
    </svg>
  );
}
